import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import DatePicker from "react-date-picker";

import moment from "moment";
import api from "../../config/api";
import editIcon from "../../assets/icons/edit.png";
import "./style.css";
import historyAction from "../../redux/history/action";
import statementGenerationAction from "../../redux/statementGeneration/action";
import alertMessage from "../../redux/auth/action";
import PageHead from "../../component/pageHead/PageHead";
import CustomButton from "../../component/CustomButton/CustomButton";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import { isNetworkRequestFailedError } from "../../config/helpers";

class StatementGeneration extends Component {
  state = {
    showLoader: false,
    showCalender: true,
  };

  handlePickerChange = (field, value) => {
    const { getMyStatement, eDate, alertBox } = this.props;

    if (field === "sDate" && eDate) {
      const startMoment = moment(value);
      const endMoment = moment(eDate);
      const isBefore = endMoment.isBefore(startMoment);
      if (isBefore) {
        alertBox({
          type: "error",
          message: "Start date can not be higher than end date",
        });

        // workaround because calender internally changes date even when
        // we don't change 'value' props
        return this.setState({ showCalender: false }, () =>
          this.setState({ showCalender: true })
        );
      }
    }

    getMyStatement({ [field]: value });
  };

  generateStatement = async () => {
    const { user, sDate, eDate, alertBox } = this.props;
    const payload = {
      sDate: moment(sDate).format("YYYY-MM-DD"),
      eDate: moment(eDate).format("YYYY-MM-DD"),
      pin: user.User.rsaPin,
    };

    try {
      this.setState({ showLoader: true });

      await api.getMyStatement(payload, user.token);
      alertBox({
        type: "success",
        message: "Successfully sent to your registered email",
      });

      this.setState({ showLoader: false });
    } catch (e) {
      alertBox({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.generateStatement
          : null,
      });
    }

    this.setState({ showLoader: false });
  };

  render() {
    const { sDate, eDate } = this.props;
    const { showLoader, showCalender } = this.state;

    return (
      <div>
        <PageHead
          containerStyles={{ width: "100%" }}
          title="STATEMENT GENERATION"
        />
        <Row className="my-3">
          <Col sm={6} className="pl-0">
            {showCalender && (
              <DatePicker
                calendarIcon={<CalenderIcon />}
                calendarClassName="statement-generation-calender-main-container"
                className="statement-generation-calender-field"
                value={sDate}
                format="M/d/yyyy"
                onChange={(value) => this.handlePickerChange("sDate", value)}
              />
            )}
          </Col>
          <Col sm={6} className="pr-0">
            <DatePicker
              calendarIcon={<CalenderIcon />}
              calendarClassName="statement-generation-calender-main-container"
              className="statement-generation-calender-field"
              value={eDate}
              minDate={sDate && new Date(moment(sDate))}
              format="M/d/yyyy"
              onChange={(value) => this.handlePickerChange("eDate", value)}
            />
          </Col>
        </Row>
        <Row className="flex1">
          <Col lg={4} md={5} sm={6} className="mx-auto pl-0 pl-sm-3 pr-0">
            <CustomButton
              buttonText="Generate Statement"
              buttonContainerClasses={"margin-y"}
              buttonStyle={{ width: "100%" }}
              onClick={() => {
                this.generateStatement();
              }}
            />
          </Col>
        </Row>

        {showLoader && <CustomLoader text={"Generating statement"} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  ...state.statementGeneration,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  alertBox: alertMessage.setAlertMessage,
  getMyStatement: statementGenerationAction.getMyStatement,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatementGeneration);

function CalenderIcon() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img alt="edit-icon" src={editIcon} width="20px" />
    </div>
  );
}
